import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "../";
/**
* @class CODAccount
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.codAccounts[0];
* const account = new CODAccount(record);
* @property {NUMBER} _mapID - used to map COD account information with account data
* @property {STRING} _interestRate - interest rate percentage
* @property {STRING} _ytdInterest - dollar amount of interest for current year
* @property {STRING} _prevYearInt - interest paid for previous year
* @property {bcmsDate} _maturityDate -  number of days in future for maturity
* @property {bcmsDate} _lastDepositDate - number of days in past for last deposit
* @property {bcmsCurrency} _lastDepositAmount - amount paid for last deposit
* @property {bcmsCurrency} _currentBalance - balance of the deposit account
* @property {bcmsCurrency} _availableBalance - available balance of the account
*/
export default class CODAccount extends BCMSRecord{
  _mapID;   
  _interestRate;  
  _ytdInterest;   
  _prevYearInt;
  _maturityDate   
  _lastDepositDate;
  _lastDepositAmount; 
  _currentBalance;
  _availableBalance;

  constructor (record){   
    super(Object.assign(record,Account.initByID(record.mapID).record))     
   }    
  }  
  CODAccount.define({
    "recordType":"codAccounts",
    "recordIDProp":"mapID",
    "className" : "CODAccount",
    "recordProperties": [
      /** 
      * @name mapID
      * @instance
      * @property get {NUMBER} - gets the mapID of the account
      * @property set {NUMBER} - sets the imapIDd of the account
      * @memberof CODAccount 
      */
      BCMSRecordProperty.mapToNumber("mapID","_mapID"),
      /** 
      * @name interestRate
      * @instance
      * @property get {STRING} - gets the interestRate of the account
      * @property set {STRING} - sets the interestRate of the account
      * @memberof CODAccount 
      */
      BCMSRecordProperty.mapToString("interestRate","_interestRate"),
      /** 
      * @name ytdInterest
      * @instance
      * @property get {STRING} - gets the ytdInterest of the account
      * @property set {STRING} - sets the ytdInterest of the account
      * @memberof CODAccount 
      */
      BCMSRecordProperty.mapToString("ytdInterest","_ytdInterest"),
      /** 
      * @name prevYearInt
      * @instance
      * @property get {STRING} - gets the prevYearInt of the account
      * @property set {STRING} - sets the prevYearInt of the account
      * @memberof CODAccount 
      */
      BCMSRecordProperty.mapToString("prevYearInt","_prevYearInt"),
      /** 
      * @name maturityDate
      * @instance
      * @property get {bcmsDate} - gets the maturityDate of the account
      * @property set {bcmsDate} - sets the maturityDate of the account
      * @memberof CODAccount 
      */
      BCMSRecordProperty.mapToDate("maturityDate","_maturityDate"),
      /** 
      * @name lastDepositDate
      * @instance
      * @property get {bcmsDate} - gets the lastDepositDate of the account
      * @property set {bcmsDate} - sets the lastDepositDate of the account
      * @memberof CODAccount 
      */
      BCMSRecordProperty.mapToDate("lastDepositDate","_lastDepositDate"),
      /** 
      * @name lastDepositAmount
      * @instance
      * @property get {bcmsCurrency} - gets the lastDepositAmount of the account
      * @property set {bcmsCurrency} - sets the lastDepositAmount of the account
      * @memberof CODAccount 
      */
      BCMSRecordProperty.mapToCurrency("lastDepositAmount","_lastDepositAmount"),
      /** 
      * @name currentBalance
      * @instance
      * @property get {bcmsCurrency} - gets the currentBalance of the account
      * @property set {bcmsCurrency} - sets the currentBalance of the account
      * @memberof CODAccount 
      */
        BCMSRecordProperty.mapToCurrency("currentBalance","_currentBalance"),

      /**
       * @name availableBalance
       * @instance
       * @property get {bcmsCurrency} - gets the availableBalance of the account
       * @property set {bcmsCurrency} - sets the availableBalance of the account
       * @memberof CODAccount
       */
      BCMSRecordProperty.mapToCurrency("availableBalance", "_availableBalance")
    ].concat(Account._RecordProperties)
})




